import React from "react";
import { ICONS } from "./iconsData";

export type IconName = keyof typeof ICONS;

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  color?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  strokeColor?: string;
  bgColor?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  //  TODO: revisar en proyecto x su uso-> color,
  width,
  height,
  className,
  strokeColor,
  bgColor,
  ...props
}) => {
  const selectedIcon = ICONS[name];

  if (!selectedIcon) return null;

  return (
    <div
      className={className}
      style={{
        backgroundColor: bgColor || "transparent",
        display: "inline-block",
        width: width || selectedIcon.width,
        height: height || selectedIcon.height,
      }}
    >
      <svg
        width={width || selectedIcon.width}
        height={height || selectedIcon.height}
        viewBox={selectedIcon.viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={strokeColor}
        {...props}
      >
        {selectedIcon.paths.map((d, index) => (
          <path key={index} d={d} fill="currentColor" />
        ))}
      </svg>
    </div>
  );
};

export default Icon;
